module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABUElEQVQ4T63Tv07CUBTH8d8ptlKMrsZ3MPEBeAOeQW1rlYsDLQzGVY2T8V8TCLUaQ9hxVDEYX8M4GFd9AEk03GMYSABbbk3s3H7O+fa2hH+6KM7ZEOUVCS2vadr9dePsNc2sWMgS3g0xCgw86SbZV0HwrsJiIXurssYkawAWAHR1k1ZVWCw0mO5sVzZlXx4AWALwQJB+M6o9J22WCBWLRf07k7NkX54AmAPwqJu0nrRZIjScbAuvzIxDVaYSSpuZCprMJKILg3s7URR9DjdPDX1R1mXGEYAcQI1Z9Hb/CpEtPMGMPQCLxLiV6Fdbl/WX0RNUbURWya9A8j6AeYDuTE23w/D4Y/IzmHr8oznE6GQzhhOHDNAk6HeOMVNt1U/HcpRpjvAcyQhUOUrIFn6bmQsgdE0y3KQcJeSWvGUpKc8adZrh+Zvqz5/2jtI8O3bPD7L7khPYUuqLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/icon-right.png
// module id = AB3e
// module chunks = 4